import React from 'react';
import { Helmet } from 'react-helmet';

import { Wrapper } from '../components/containers/Wrapper';
import { HeroContainer } from '../components/containers/HeroContainer';
import { ContentContainer } from '../components/containers/ContentContainer';
import { LocationCards } from '../components/LocationCards';
import { CardContainer } from '../components/containers/CardContainer';

const Home = () => {
    return (
        <Wrapper>
            <Helmet>
                <meta property="og:title" content="12th Avenue Cafe" />
                <meta property="og:image" content="https://res.cloudinary.com/dwot7f2oz/image/upload/q_auto,f_auto,w_auto,dpr_auto/12th-ave-cafe/food/IMG_0_cwvep3.jpg" />
                <meta property="og:url" content="https://12thavenuecafe.com" />
            </Helmet>
            <HeroContainer>
                <h1 className="text-shadow-pop-bl">Welcome to<br /> 12th Avenue Cafe!</h1>
            </HeroContainer>
            <ContentContainer>
                <div className="content">
                    <h2><span>About Us</span></h2>
                    <p>
                        Established in 1991, 12th Avenue Cafe prides itself in being the neighborhood diner you can count on. From the beginning, we have always strived to provide a friendly, reliable, and consistently great dining experience. 
                        It is always our goal to use the freshest ingredients and provide hearty portions at fair, affordable prices to ensure our guests have a satisfying experience every time they leave our diner. 
                    </p>
                    <h3>Vote for Us!</h3>
                    <CardContainer>
                        <img src="https://res.cloudinary.com/dwot7f2oz/image/upload/v1778446503/the-egg-and-us/2025BPNW_VoteFlyer_ejlhkh.png" alt="2026 Best in the PNW Voter Flyer" />
                    </CardContainer>
                    <p>We've been nominated for The Seattle Times Best in the PNW for 2026! Voting begins on Monday June 8th at 11:55 AM and ends on Friday June 26th 
                        at 5:00 PM. Fans can send in a vote once per day so be sure to vote for 12th Avenue Cafe as much as you can to show your love and support! Scan the QR code or visit 
					    the following link to vote for us: <a href="https://www.votethepnw.com/" target="_blank" rel="noreferrer noopener">Vote Here!</a>
                    </p>
                </div>
                <div className="content">
                    <h2><span>Location</span></h2>
                    <a href="https://www.google.com/maps/search/775+NW+Gilman+Blvd,+Issaquah,+WA+98027" target="_blank" rel="noreferrer noopener">775 NW Gilman Blvd, Issaquah, WA 98027</a>
                    <br />
                    <a href="tel:425-392-5975" data-bb-track-label="Location" data-bb-track="button" data-bb-track-on="click" data-bb-track-action="Click" data-bb-track-category="Phone Number">425-392-5975</a>
                </div>
                <div className="content">
                    <h2><span>Hours</span></h2>
                    <p>Monday - Saturday: 7:00 AM - 8:00 PM</p>
                    <p>Sunday: 7:00 AM - 3:00 PM</p>
                </div>
                <div className="content">
                    <p className="mt-4">Come visit us at any one of our other restaurants!</p>
                    <LocationCards />
                </div>
            </ContentContainer>
        </Wrapper>
    );
}

export default Home;